import { createSlice } from '@reduxjs/toolkit';
import { REHYDRATE } from "redux-persist";

const rehydratedSlice = createSlice({
    name: "rehydrated",
    initialState: false,
    reducers: {
    },
    extraReducers: (builder) => {
        builder.addCase(REHYDRATE, () => true); 
    },
});

const { reducer } = rehydratedSlice

export default reducer
